import React, { useMemo, useState, useEffect } from 'react';
import Table from '../../../../components/Tables/ReportTable';
import { headerMaker } from '../../../../components/Tables/ExpandedTable/helper';
import reportService from '../../../../services/reports';
import { useSelector } from 'react-redux';
import { checkWorkAndPlan } from '../../../../utils/makeReport';
import Spinner from 'components/Spinner';
import { Empty } from 'antd';
import { usePaginate } from 'hooks/usePaginate';

export default ({ active }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newHeader, setNewHeader] = useState([]);
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { data, handleOnTableChange, pageCount } = usePaginate();

  const { categories } = useSelector((state) => state.appReducer);

  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  useEffect(() => {
    setLoading(true);
    let data = {
      start: selectedDate[0],
      end: selectedDate[1],
    };
    if (!selectedDate.every((item) => item === '') && active !== '') {
      data = { ...data, group: active };
      reportService
        .getAllReportBySubCategories(data)
        .then((resp) => {
          createUserData(resp);
          makeReportHeaders(resp);
        })
        .finally(() => setLoading(false))
        .catch((err) => console.log(err));
    }
  }, [active, dateQuery]);

  const makeReportHeaders = (data = []) => {
    const hechCategories = new Map();
    categories.forEach((item) => hechCategories.set(item._id, item));
    const headerCats =
      data[0] &&
      data[0].subs.map((item) => hechCategories.get(item.subCategory));
    let subHeaders = [
      {
        Header: 'Т/р',
        columns: [
          {
            width: 50,
            Header: 'header_100',
            accessor: 'id',
            displayNone: true,
          },
        ],
        rowSpan: '2',
        show: true,
        width: 50,
      },
      {
        Header: 'FISH',
        columns: [
          {
            width: 250,
            accessor: 'name',
            Header: 'header_2',
            displayNone: true,
          },
        ],
        rowSpan: '2',
        show: true,
        width: 250,
        textAlign: 'left',
      },
    ];
    if (subHeaders.length == 2) {
      headerCats &&
        headerCats.forEach((item) => {
          item &&
            subHeaders.push({
              Header: item?.title,
              show: true,
              height: 100,
              columns: [
                {
                  width: 50,
                  Header: 'Режа',
                  accessor: item?._id + 'plan',
                },
                {
                  width: 50,
                  Header: 'Амалда',
                  accessor: item?._id + 'work',
                },
                {
                  width: 50,
                  Header: 'Фоизи',
                  accessor: item?._id + 'percent',
                },
              ],
            });
        });
    }
    setNewHeader(subHeaders);
  };

  const headers = useMemo(() => headerMaker(newHeader), [newHeader]);

  const createUserData = (data) => {
    const rowData = data?.map((item, ind) => {
      let row = {
        id: ind + 1,
        name: `${item.user?.firstName} ${item.user?.lastName} ${item.user?.middleName}`,
      };
      item.subs.forEach((itm) => {
        row[itm.subCategory + 'plan'] = itm.plan;
        row[itm.subCategory + 'work'] = itm.work;
        row[itm.subCategory + 'percent'] =
          checkWorkAndPlan(itm.work, itm.plan) + '%';
      });
      return row;
    });
    setRows(rowData);
  };
  if (loading) return <Spinner maxHeight='100%' />;

  return rows.length > 0 ? (
    <Table
      data={data}
      headers={headers}
      withExcel={true}
      onChange={handleOnTableChange}
      total={rows.length}
      reportsData={rows}
      page={pageCount}
      tableName='Субкатегориялар бўйича'
    />
  ) : (
    <Empty
      description='Маълуьмот топилмади'
      image={Empty.PRESENTED_IMAGE_SIMPLE}
    />
  );
};
